import Vue from 'vue';
import AsyncComputed from 'vue-async-computed';
import { captureException } from '@sentry/browser';

Vue.use(AsyncComputed, {
    useRawError: true,
    errorHandler: (err) => {
        if (process.env.NODE_ENV === 'development') {
            throw err;
        }

        captureException(err);
    },
});
